<template>
  <SrpModal :isVisible="props.isVisible" @update:isVisible="isVisible => emit('update:isVisible', isVisible)">
    <template #content>
      <ZipFileGenAnimMiniIllustration style="width: 130px; margin: 0 auto 10px" />

      <h1 class="global-h1" style="margin-bottom: 15px; text-align: center">We are compiling a ZIP archive of files for you</h1>
      <p class="global-p" style="text-align: center">
        This may take a few minutes.<br />
        <b>We will notify you via email when it is ready.</b>
      </p>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
// Components
import ZipFileGenAnimMiniIllustration from "@components/AnimatedMiniIllustrations/ZipFileGenAnimMiniIllustration.vue";
import SrpModal from "@components/ui/SrpModal.vue";

const props = withDefaults(
  defineProps<{
    isVisible: boolean;
  }>(),
  {
    isVisible: false,
  }
);

const emit = defineEmits<{
  (e: "update:isVisible", value: boolean): void;
}>();
</script>
